import appConfig from '../../appConfig';

const kidbizURL = appConfig.KIDBIZ_HOST;

const keepAliveAPI = () => { fetch(`${kidbizURL}/kb/login/keep_alive`, { mode: 'cors', credentials: 'include' }); }

export default keepAliveAPI;
